import Link from 'gatsby-link'
import * as React from 'react'
import './PrimaryButton.scss'

interface IProps {
  className?: string
  text: string
  to?: string
  callback?: () => void
  disabled?: boolean
}

const PrimaryButton: React.StatelessComponent<IProps> = (props) => {
  const {className, text, to, callback, disabled} = props;

  const classes = 'primarybutton' + ' ' + className;

  return (to !== undefined ? (
    <Link className={classes} to={disabled ? '' : to}><span>{text}</span></Link>
  ) : (
    <button disabled={disabled} className={'primarybutton' + ' ' + className} onClick={callback}>
      <span>
        {text}
      </span>
    </button>
  ))
}

export default PrimaryButton



// WEBPACK FOOTER //
// ./src/components/PrimaryButton.tsx